import script from "./WorkspaceGroupsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceGroupsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceGroupsTableLoader.vue?vue&type=style&index=0&id=fff7cb08&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff7cb08"]])

export default __exports__